// skio-build-a-box-v3.js — Dynamic Box variant
// Uses dynamic import to avoid "LitElement already declared" conflict
// when skio-build-a-box.js is also on the same page.

if (!customElements.get("skio-build-a-box-v3")) {
  import("https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js").then(
    ({ LitElement, html, css }) => {
      // ─────────────────────────────────────────────────────────
      // Shared helpers (mirrors v1/v2 scope)
      // ─────────────────────────────────────────────────────────
      const moneyFormatterV3 = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: window?.Shopify?.currency?.active || "USD",
      });
      const moneyV3 = (price) => moneyFormatterV3.format(price / 100.0);
      const moneyZerosV3 = (price) => (price / 100).toFixed(0).toString();

      // ─────────────────────────────────────────────────────────
      // Same CSS as skio-build-a-box.js (skioStyles) — verbatim copy
      // ─────────────────────────────────────────────────────────
      const skioStyles = css`
        .hidden {
          display: none;
        }
        .skio-bab {
          --primary: black;
          --primary-hover: white;
          --font-primary: "xyngia", sans-serif;
          --font-secondary: Assistant, sans-serif;
        }
        .skio-bab {
          display: block;
          margin: auto;
          max-width: 1500px;
          padding: 140px 30px;
          color: #000;
          font-family: var(--font-primary) !important;
          padding-top: 140px;
          z-index: 3;
          position: relative;
        }
        .skio-bab-sticky_atc {
          position: fixed;
          bottom: 0%;
          width: 100vw;
          background-color: white;
          border-top: 1px solid black;
        }
        .skio-bab__title {
          font-style: normal;
          font-weight: 800;
          font-size: 30px;
          line-height: 35px;
          margin: 0;
        }
        .skio-bab__subtitle {
          max-width: 740px;
          font-family: "ibm_plex_sanssemibold";
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.05em;
          color: #767c82;
          text-transform: uppercase;
        }
        .skio-bab-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          grid-template-areas: "products products products products cart cart cart";
          grid-auto-rows: max-content;
          align-items: flex-start;
          gap: 2rem;
        }
        .skio-bab-products {
          grid-area: products;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          grid-row-gap: 3rem;
          grid-column-gap: 2rem;
        }
        .skio-bab-cart {
          grid-area: cart;
          width: 100%;
          display: flex;
          flex-direction: column;
          position: sticky;
          top: 8rem;
        }
        .skio-bab-cart__title {
          text-align: center;
          margin: 1rem;
          font-family: var(--font-primary);
          font-size: 3rem;
        }
        .skio-bab-product-card {
          text-align: center;
          line-height: 120%;
          color: #000;
        }
        .skio-bab-product-card__image img {
          display: block;
          max-width: 100%;
          height: auto;
          transition: transform 0.3s ease;
        }
        .skio-bab-product-card__image {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .skio-bab-product-card__image img:hover {
          transform: scale(1.05);
          cursor: pointer;
        }
        .skio-bab-product-card__titlegroup {
          min-height: 4lh;
        }
        .skio-bab-product-card__title {
          font-weight: 500;
          text-align: center;
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 6px;
        }
        .skio-bab-product-card__atc {
          width: 30%;
          text-transform: uppercase;
        }
        .skio-bab-quantity-picker {
          display: flex;
          gap: 1.5rem;
          margin: auto;
          justify-content: center;
        }
        .skio-bab-quantity-picker__status {
          line-height: 175%;
        }
        button.skio-bab-quantity-picker__btn {
          width: 30px;
          height: 30px;
          padding: 0;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .skio-bab-cart__visual {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }
        .skio-bab-cart__visual-item {
          width: 50%;
        }
        .skio-bab-cart__visual-item img {
          width: 90%;
        }
        .skio-bab-cart-footer__description {
          color: #1b1b1b;
          margin-top: 20px;
          font-family: vollkorn;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 30px;
        }
        .skio-bab-cart__footer {
          margin-top: 2rem;
        }
        .skio-bab-cart__checkout {
          margin-top: 1rem;
          font-size: 16px;
          padding: 1.5rem 2rem;
          display: block;
          text-decoration: none;
          text-align: center;
          font-family: var(--font-primary) !important;
        }
        .skio-bab-cart__info {
          margin: 0;
          font-size: 11px;
        }
        .btn {
          background-color: var(--primary);
          border: none;
          color: white;
          border-radius: 5px;
          font-weight: 700;
          cursor: pointer;
          transition: 200ms ease;
          padding: 0.7em 3em;
          width: auto;
          border: 1px solid black;
        }
        .btn:hover {
          background-color: var(--primary-hover);
          color: var(--primary);
        }
        .btn:disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        .skio-bab-box-size-selector button {
          padding: 10px;
          border-radius: 7px;
          background: transparent;
          font-size: 20px;
          font-weight: 500;
          font-family: var(--font-primary) !important;
          display: inline-block;
          border: 1px solid #767c82;
          box-sizing: border-box;
          border-radius: 8px;
          overflow: hidden;
          margin-right: 15px;
          width: 50px;
          height: 50px;
          transition: 200ms ease;
        }
        .skio-bab-box-size-selector button.selected {
          background: black;
          color: white;
        }
        .skio-bab-box-size-selector button:hover {
          cursor: pointer;
        }
        .skio-bab-box-size-selector button:not(.selected):hover {
          background: white;
        }
        .skio-plan-picker {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 0;
          border: 0;
        }
        .skio-onetime-second {
          order: 2;
        }
        .skio-group-container {
          display: none;
        }
        .skio-group-container--available {
          display: block;
          position: relative;
          border-radius: 8px;
          background-color: transparent;
          opacity: 0.5;
        }
        .skio-group-container--selected {
          opacity: 1;
        }
        .skio-group-container--selected::before {
          content: "";
          position: absolute;
          top: calc(var(--variant-pills-border-width, 0px) * -1);
          right: calc(var(--variant-pills-border-width, 0px) * -1);
          bottom: calc(var(--variant-pills-border-width, 0px) * -1);
          left: calc(var(--variant-pills-border-width, 0px) * -1);
          z-index: -1;
          border-radius: var(--variant-pills-radius, 8px);
          box-shadow: var(--variant-pills-shadow-horizontal-offset, 0px)
            var(--variant-pills-shadow-vertical-offset, 0px)
            var(--variant-pills-shadow-blur-radius, 0px)
            rgba(
              var(--color-shadow, 0, 0, 0),
              var(--variant-pills-shadow-opacity, 0)
            );
        }
        .skio-group-input {
          position: absolute;
          width: 0px;
          height: 0px;
          opacity: 0;
        }
        .skio-group-label {
          display: flex;
          flex-direction: column;
          cursor: pointer;
          padding: 10px;
          overflow: hidden;
          border-radius: 8px;
          transition: 200ms ease;
        }
        .skio-group-label:hover {
          background-color: white;
        }
        .skio-group-topline {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          font-size: 16px;
          font-weight: 500;
        }
        .skio-radio__container {
          display: flex;
          margin-right: 10px;
        }
        .skio-radio {
          transition:
            transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
            opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          transform-origin: center;
          transform: scale(0);
          opacity: 0;
        }
        .skio-group-label:hover .skio-radio {
          transform: scale(1);
          opacity: 0.75;
        }
        .skio-group-container--selected .skio-group-label .skio-radio {
          transform: scale(1);
          opacity: 1;
        }
        .skio-price {
          margin-left: auto;
        }
        .skio-group-content {
          width: auto;
          margin-left: 30px;
          transition:
            max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1),
            opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          max-height: 520px;
          opacity: 1;
        }
        .skio-group-container:not(.skio-group-container--selected)
          .skio-group-content {
          max-height: 0;
          opacity: 0;
          pointer-events: none;
        }
        .skio-group-title {
          min-width: max-content;
        }
        .skio-save {
          color: #0fa573;
          border: 1px #0fa573 solid;
          padding: 0px 8px;
          border-radius: 20px;
        }
        .skio-frequency {
          display: flex;
          align-items: center;
          gap: 5px;
          box-sizing: border-box;
          padding: 8px 30px 8px 10px;
          margin-top: 5px;
          border-radius: 5px;
          background-color: #f7f7f7;
          width: 75%;
          border: 1px solid #b2b2b2;
          font-size: 14px;
          font-family: inherit;
          white-space: nowrap;
          text-overflow: ellipsis;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
          background-position: right 10px top 50%;
          background-size: 18px;
          background-repeat: no-repeat;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          outline: none;
        }
        .skio-frequency:focus,
        .skio-frequency:focus-visible {
          outline: none;
          box-shadow: none;
          border-color: #111;
        }
        .skio-frequency.skio-frequency--one {
          background-image: none;
          pointer-events: none;
        }
        .skio-frequency span {
          text-transform: lowercase;
        }
        .options-text {
          margin-top: 8px;
        }
        .options-text__item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;
          font-size: 12px;
        }
        .options-text__item-icon img {
          width: 18px;
          height: 18px;
          object-fit: contain;
        }
        .skio-group-content__total {
          display: flex;
          gap: 8px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .skio-bab-cart__buy-it-once {
          margin-top: 8px;
          text-align: center;
        }
        .skio-bab-cart__buy-it-once-btn {
          color: #767c82;
          font-size: 13px;
          text-decoration: underline;
          cursor: pointer;
        }
        .skio-bab-cart__buy-it-once-btn.disabled {
          opacity: 0.4;
          pointer-events: none;
        }
        .skio-loading {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 300px;
        }
        .lds-roller {
          display: inline-block;
          position: relative;
          width: 80px;
          height: 80px;
        }
        .lds-roller div {
          animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          transform-origin: 40px 40px;
        }
        .lds-roller div:after {
          content: " ";
          display: block;
          position: absolute;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #111;
          margin: -4px 0 0 -4px;
        }
        .lds-roller div:nth-child(1) {
          animation-delay: -0.036s;
        }
        .lds-roller div:nth-child(1):after {
          top: 63px;
          left: 63px;
        }
        .lds-roller div:nth-child(2) {
          animation-delay: -0.072s;
        }
        .lds-roller div:nth-child(2):after {
          top: 68px;
          left: 56px;
        }
        .lds-roller div:nth-child(3) {
          animation-delay: -0.108s;
        }
        .lds-roller div:nth-child(3):after {
          top: 71px;
          left: 48px;
        }
        .lds-roller div:nth-child(4) {
          animation-delay: -0.144s;
        }
        .lds-roller div:nth-child(4):after {
          top: 72px;
          left: 40px;
        }
        .lds-roller div:nth-child(5) {
          animation-delay: -0.18s;
        }
        .lds-roller div:nth-child(5):after {
          top: 71px;
          left: 32px;
        }
        .lds-roller div:nth-child(6) {
          animation-delay: -0.216s;
        }
        .lds-roller div:nth-child(6):after {
          top: 68px;
          left: 24px;
        }
        .lds-roller div:nth-child(7) {
          animation-delay: -0.252s;
        }
        .lds-roller div:nth-child(7):after {
          top: 63px;
          left: 17px;
        }
        .lds-roller div:nth-child(8) {
          animation-delay: -0.288s;
        }
        .lds-roller div:nth-child(8):after {
          top: 56px;
          left: 12px;
        }
        @keyframes lds-roller {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* skio-bab__filters (same as v2 external css, replicated here for shadow-DOM) */
        .skio-bab__filters {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          margin-bottom: 14px;
          padding-bottom: 4px;
          flex-wrap: wrap;
        }
        .skio-bab__filters-card {
          border: 1px solid #111;
          border-radius: 999px;
          padding: 6px 14px;
          background: #fff;
          cursor: pointer;
          white-space: nowrap;
          font-weight: 700;
          font-size: 13px;
          text-transform: capitalize;
        }
        .skio-bab__filters-card:hover {
          background: #f7f7f7;
        }
        .skio-bab__filters-card.active {
          background: #fff;
          border-color: #282826;
          color: inherit;
        }
        .skio-bab__subtitle-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: #111;
          color: #fff;
          font-size: 12px;
          margin-right: 6px;
        }
        .skio-bab__subtitle-name {
          margin-right: 8px;
        }
        .skio-bab__subtitle-quantity {
          margin-left: auto;
          font-size: 12px;
        }
        .skio-bab__subtitle-line {
          flex: 1;
          height: 1px;
          background: #e0e0e0;
          display: inline-block;
          vertical-align: middle;
        }

        /* Product card badge */
        .skio-bab-product-card__badge {
          position: absolute;
          top: -10px;
          right: -10px;
          background: #000;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          font-family: sans-serif;
          padding: 4px 6px;
          border-radius: 50%;
          line-height: 1.2;
          text-align: center;
          width: 38px;
          height: 38px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0;
          pointer-events: none;
        }

        /* Category grouping (replicated from skio-bab.css for safety) */
        .skio-bab-category {
          margin-bottom: 2.5rem;
        }
        .skio-bab-category__title {
          font-size: 16px;
          font-family: "xyngia", sans-serif;
          font-weight: 700;
          margin: 0 0 1rem;
          text-transform: capitalize;
        }
        .skio-bab-products--category {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, max-content));
          grid-row-gap: 3rem;
          grid-column-gap: 2rem;
        }
        .skio-bab-category.hidden {
          display: none;
        }

        @media (max-width: 992px) {
          .skio-bab-grid {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
        @media (max-width: 700px) {
          .skio-bab-products {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          }
          .skio-bab-product-card__image {
            padding: 15px 0;
          }
          .skio-bab-product-card__image img {
            height: 150px;
            width: auto;
            max-width: 100%;
            object-fit: contain;
          }
        }
      `;

      // ─────────────────────────────────────────────────────────
      // Component
      // ─────────────────────────────────────────────────────────
      class SkioBuildABoxV3Component extends LitElement {
        static styles = skioStyles;

        static properties = {
          dynamicProductPlatformId: {
            type: String,
            attribute: "dynamic-product-platform-id",
          },
          dynamicProductHandle: {
            type: String,
            attribute: "dynamic-product-handle",
          },
          defaultPurchaseOption: {
            type: String,
            attribute: "default-purchase-option",
          },
          filterDataId: { type: String, attribute: "filter-data-id" },
          badgeDataId: { type: String, attribute: "badge-data-id" },
          variantCatalogDataId: {
            type: String,
            attribute: "variant-catalog-data-id",
          },
          packConfigId: { type: String, attribute: "pack-config-id" },
          filterBehavior: { type: String, attribute: "filter-behavior" },
          mobilePageDescription: {
            type: String,
            attribute: "mobile-page-description",
          },
          cartFooterDescription: {
            type: String,
            attribute: "cart-footer-description",
          },
          loading: { type: Boolean },
          errorMessage: { type: String },
          dynamicBox: { type: Object },
          staticBoxes: { type: Array },
          selectedBox: { type: Object },
          staticChildVariants: { type: Array },
          cartItems: { type: Array },
          purchaseOption: { type: String },
          selectedSellingPlanGroup: { type: Object },
          selectedSellingPlan: { type: Object },
          availableSellingPlans: { type: Array },
          selectedFilter: { type: String },
          filterButtons: { type: Array },
          screenSize: { type: Number },
          cartVisualMinimized: { type: Boolean },
          subscriptionFirst: { type: Boolean },
        };

        constructor() {
          super();
          this.dynamicProductPlatformId = "";
          this.dynamicProductHandle = "";
          this.defaultPurchaseOption = "subscription";
          this.filterDataId = "";
          this.badgeDataId = "";
          this.variantCatalogDataId = "";
          this.packConfigId = "";
          this.filterBehavior = "scroll_to_category";
          this._packConfig = {};
          this.mobilePageDescription = "";
          this.cartFooterDescription = "";
          this.loading = true;
          this.errorMessage = "";
          this.dynamicBox = null;
          this.staticBoxes = [];
          this.selectedBox = { size: 0 };
          this.staticChildVariants = [];
          this.cartItems = [];
          this.purchaseOption = "subscription";
          this.selectedSellingPlanGroup = null;
          this.selectedSellingPlan = null;
          this.availableSellingPlans = [];
          this.selectedFilter = "All Products";
          this.filterButtons = [];
          this.screenSize = window.innerWidth;
          this.cartVisualMinimized = this.screenSize < 993;
          this.subscriptionFirst = false;
          this._badgeData = {};
          this._variantCatalog = {};
          this._handleResize = () => {
            this.screenSize = window.innerWidth;
            const isMobile = this.screenSize < 993;
            const isFull =
              this.totalItems >= this.boxCapacity && this.boxCapacity > 0;
            if (isMobile && !isFull) this.cartVisualMinimized = true;
            this.requestUpdate();
          };
        }

        // ── createRenderRoot: same as v1 — renders into light DOM so
        //    global skio-bab.css (loaded by the Liquid section) also applies.
        createRenderRoot() {
          return this;
        }

        async connectedCallback() {
          super.connectedCallback();
          window.addEventListener("resize", this._handleResize);
          try {
            this.purchaseOption =
              this.defaultPurchaseOption === "onetime"
                ? "onetime"
                : "subscription";
            this.filterButtons = this.parseFilterButtons();
            this._badgeData = this.parseBadgeData();
            this._variantCatalog = this.parseVariantCatalog();
            this._packConfig = this.parsePackConfig();
            console.log("[skio-v3] packConfig:", this._packConfig);
            const pid = await this.resolveProductPlatformId();
            this.dynamicBox = await this.getDynamicBox(pid);
            console.log(
              "[skio-v3] dynamicBox payload:",
              JSON.parse(JSON.stringify(this.dynamicBox)),
            );
            console.log(
              "[skio-v3] dynamicBox selectable products:",
              (this.dynamicBox?.selectableProductVariants || []).map(
                (entry) => ({
                  productTitle: entry?.productTitle || "",
                  productHandle: entry?.productHandle || "",
                  variants: (entry?.productVariants || []).map((v) => ({
                    platformId: v?.platformId || "",
                    productVariantTitle: v?.productVariantTitle || "",
                    imageSrc: v?.imageSrc || "",
                    price: v?.price ?? null,
                  })),
                }),
              ),
            );
            this.staticChildVariants = await this.getVariantsWithTags(
              this.dynamicBox,
            );
            console.log(
              "[skio-v3] staticChildVariants (after tag enrichment):",
              (this.staticChildVariants || []).map((v) => ({
                platformId: v?.platformId || "",
                productTitle: v?.productTitle || "",
                productVariantTitle: v?.productVariantTitle || "",
                productSlug: v?.productSlug || "",
                tags: v?.tags || [],
                available: v?.available,
                badge: v?.productCardBadge || "",
              })),
            );
            this.staticBoxes = this.buildBoxSizes(this.dynamicBox);
            this.selectedBox = this.staticBoxes[0] || { size: 0 };
            console.log(
              "[skio-v3] staticBoxes:",
              this.staticBoxes,
              "→ selectedBox.size:",
              this.selectedBox.size,
            );
            this.availableSellingPlans = this.buildSellingPlans(
              this.dynamicBox,
            );
            if (
              this.purchaseOption === "subscription" &&
              this.availableSellingPlans.length
            ) {
              this.syncSelectedSellingPlanForCurrentPack();
            }
          } catch (err) {
            this.errorMessage =
              err?.message || "Failed to load dynamic build-a-box";
          } finally {
            this.loading = false;
          }
        }

        disconnectedCallback() {
          super.disconnectedCallback();
          window.removeEventListener("resize", this._handleResize);
        }

        // ── Data helpers ───────────────────────────────────────

        parseFilterButtons() {
          const id = (this.filterDataId || "").trim();
          if (!id) return [];
          const el = document.getElementById(id);
          if (!el) return [];
          try {
            return JSON.parse(el.textContent);
          } catch {
            return [];
          }
        }

        parseBadgeData() {
          const id = (this.badgeDataId || "").trim();
          if (!id) {
            console.warn("[skio-v3] badge-data-id attribute missing");
            return {};
          }
          const el = document.getElementById(id);
          if (!el) {
            console.warn("[skio-v3] badge script tag not found:", id);
            return {};
          }
          try {
            const data = JSON.parse(el.textContent) || {};
            console.log("[skio-v3] _badgeData parsed:", data);
            return data;
          } catch (e) {
            console.warn("[skio-v3] badge JSON parse error:", e);
            return {};
          }
        }

        parseVariantCatalog() {
          const id = (this.variantCatalogDataId || "").trim();
          if (!id) return {};
          const el = document.getElementById(id);
          if (!el) return {};
          try {
            return JSON.parse(el.textContent) || {};
          } catch (e) {
            console.warn("[skio-v3] variant catalog JSON parse error:", e);
            return {};
          }
        }

        // Returns { "12": { price, comparePrice, save }, "24": {...}, "48": {...} }
        parsePackConfig() {
          const id = (this.packConfigId || "").trim();
          if (!id) return {};
          const el = document.getElementById(id);
          if (!el) return {};
          try {
            return JSON.parse(el.textContent) || {};
          } catch {
            return {};
          }
        }

        // Pack config entry keyed by displaySize (12, 24, 36, 48).
        currentPackCfg() {
          const ds =
            this.selectedBox?.displaySize || (this.selectedBox?.size || 0) * 12;
          return this._packConfig[String(ds)] || null;
        }

        slugify(str) {
          return (str || "")
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "");
        }

        async resolveProductPlatformId() {
          const direct = String(this.dynamicProductPlatformId || "").trim();
          if (direct) return direct;
          const handle = String(this.dynamicProductHandle || "").trim();
          if (!handle)
            throw new Error(
              "Provide dynamic-product-platform-id or dynamic-product-handle",
            );
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) throw new Error(`Product not found: ${handle}`);
          const p = await res.json();
          return String(p.id);
        }

        async getDynamicBox(productPlatformId) {
          console.log(
            "[skio-v3] getDynamicBox request productPlatformId:",
            productPlatformId,
          );
          const res = await fetch(
            "https://api.skio.com/storefront-http/get-dynamic-box",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ productPlatformId }),
            },
          );
          const payload = await res.json();
          if (!res.ok || payload?.ok === false)
            throw new Error("Skio dynamic box request failed");
          const box = payload.DynamicBox || payload.dynamicBox || payload;
          console.log("[skio-v3] getDynamicBox response ids:", {
            boxId: box?.boxId,
            id: box?.id,
            platformId: box?.platformId,
            title: box?.title,
            selectableCount: (box?.selectableProductVariants || []).length,
          });
          return box;
        }

        buildBoxSizes(box) {
          if (!box) return [];
          let sizes = [];
          if (Array.isArray(box.sizeInterval) && box.sizeInterval.length)
            sizes = box.sizeInterval;
          else if (Array.isArray(box.sizeRange) && box.sizeRange.length >= 2) {
            const [min, max] = [
              Number(box.sizeRange[0]),
              Number(box.sizeRange[1]),
            ];
            sizes = Array.from(
              { length: Math.max(0, max - min + 1) },
              (_, i) => min + i,
            );
          }
          // Only keep sizes 2 (24-pack) and 4 (48-pack)
          const ALLOWED_SIZES = [2, 4];
          return sizes
            .filter((s) => ALLOWED_SIZES.includes(Number(s)))
            .map((s) => {
              const unit = Number(s);
              const displaySize = unit * 12; // 2→24, 4→48
              const save = box.fixedDiscountTier?.[String(unit)] || null;
              return {
                size: unit,
                displaySize,
                save,
                title: `${displaySize} PACK`,
                platformId: box.platformId || "",
              };
            });
        }

        buildSellingPlans(box) {
          const group = box?.sellingPlanGroup;
          if (!group || typeof group !== "object") return [];
          return Object.entries(group).map(([id, plan]) => ({
            id,
            name:
              plan.title ||
              `${plan.intervalCount || 1} ${plan.interval || "week"}`,
            intervalCount: plan.intervalCount || 1,
            interval: plan.interval || "week",
            raw: plan,
            // mimic Shopify selling_plan.price_adjustments for discount calc
            price_adjustments: plan.priceAdjustmentType
              ? [
                  {
                    value_type:
                      plan.priceAdjustmentType === "PERCENTAGE"
                        ? "percentage"
                        : "fixed_amount",
                    value: Number(plan.priceAdjustmentAmount || 0),
                  },
                ]
              : [{ value_type: "percentage", value: 0 }],
          }));
        }

        allowedIntervalsForCurrentPack() {
          const size = Number(this.selectedBox?.size || 0);
          if (size === 2) return [2, 4, 6]; // 24 pack
          if (size === 4) return [4, 6, 8]; // 48 pack
          return [];
        }

        defaultIntervalForCurrentPack() {
          const size = Number(this.selectedBox?.size || 0);
          if (size === 2) return 4; // 24 pack default
          if (size === 4) return 6; // 48 pack default
          return null;
        }

        plansForCurrentPack() {
          const plans = this.availableSellingPlans || [];
          const allowed = this.allowedIntervalsForCurrentPack();
          if (!allowed.length) return plans;
          return plans.filter((p) =>
            allowed.includes(Number(p.intervalCount || 0)),
          );
        }

        syncSelectedSellingPlanForCurrentPack(forceDefault = false) {
          const plans = this.plansForCurrentPack();
          if (!plans.length) {
            this.selectedSellingPlan = null;
            this.selectedSellingPlanGroup = null;
            return;
          }

          if (!forceDefault) {
            const currentStillAllowed = plans.some(
              (p) => String(p.id) === String(this.selectedSellingPlan?.id),
            );
            if (currentStillAllowed) return;
          }

          const defaultInterval = this.defaultIntervalForCurrentPack();
          const preferred =
            plans.find(
              (p) => Number(p.intervalCount || 0) === defaultInterval,
            ) || plans[0];
          this.selectedSellingPlan = preferred;
          // v3 uses a single subscription card, keep first allowed as group marker
          this.selectedSellingPlanGroup = plans[0];
        }

        async getVariantsWithTags(box) {
          const variants = [];

          // Primary payload shape
          (box?.selectableProductVariants || []).forEach((entry) => {
            (entry.productVariants || []).forEach((v) => {
              variants.push({
                platformId: v.platformId,
                productTitle: entry.productTitle || "",
                productVariantTitle: v.productVariantTitle || "",
                productSlug: entry.productHandle || "",
                imageSrc: v.imageSrc || entry.productImageSrc || "",
                price: Number(v.price || 0),
                tags: [],
                available: true,
              });
            });
          });

          // Merge variants referenced by sellingPlan mappings that may be omitted
          // from selectableProductVariants (e.g. OOS items like Cafe Mocha/Dark Choc).
          const mappedVariantIds = new Set();
          Object.values(box?.sellingPlanGroup || {}).forEach((plan) => {
            const vm = plan?.variantMapping || {};
            Object.keys(vm).forEach((gid) => {
              const numeric = String(this.gid(gid));
              if (numeric && numeric !== "NaN") mappedVariantIds.add(numeric);
            });
          });
          if (mappedVariantIds.size) {
            const seenNumeric = new Set(
              variants.map((v) => String(this.gid(v.platformId))),
            );
            const missing = [...mappedVariantIds].filter(
              (id) => !seenNumeric.has(id),
            );
            if (missing.length) {
              console.warn(
                "[skio-v3] merging missing variants from sellingPlanGroup.variantMapping:",
                missing,
              );
            }
            missing.forEach((id) => {
              const c = this._variantCatalog?.[id];
              if (!c) return;
              variants.push({
                platformId: `gid://shopify/ProductVariant/${id}`,
                productTitle: c.productTitle || "",
                productVariantTitle: c.variantTitle || "",
                productSlug: c.productHandle || "",
                imageSrc: c.imageSrc || "",
                price: Number(c.priceCents || 0) / 100,
                tags: [],
                // Business rule: variants coming from this fallback source
                // must always be shown as out of stock.
                forceOutOfStock: true,
                available: false,
              });
            });
          }

          const handles = [
            ...new Set(variants.map((v) => v.productSlug).filter(Boolean)),
          ];
          const tagsByHandle = {};
          await Promise.all(
            handles.map(async (h) => {
              try {
                const r = await fetch(`/products/${h}.js`);
                if (!r.ok) return;
                const p = await r.json();
                tagsByHandle[h] = Array.isArray(p.tags) ? p.tags : [];
              } catch {}
            }),
          );
          const result = variants.map((v) => ({
            ...v,
            tags: tagsByHandle[v.productSlug] || [],
            available:
              !v.forceOutOfStock &&
              !(tagsByHandle[v.productSlug] || []).includes("OOS"),
            productCardBadge: (this._badgeData || {})[v.productSlug] || null,
          }));
          console.log("[skio-v3] variant slugs:", [
            ...new Set(variants.map((v) => v.productSlug)),
          ]);
          const withBadge = result.filter((v) => v.productCardBadge);
          console.log(
            "[skio-v3] variants with badge:",
            withBadge.map((v) => `${v.productSlug} → "${v.productCardBadge}"`),
          );
          if (!result.length) {
            console.warn(
              "[skio-v3] No variants resolved. dynamicBox.settings keys:",
              Object.keys(box?.settings || {}),
            );
          }
          return result;
        }

        // ── Cart helpers (same API as v1) ──────────────────────

        get totalItems() {
          return this.cartItems.reduce((s, i) => s + i.quantity, 0);
        }

        // boxCapacity = Skio size units (1, 2, 3, 4) — the actual item slots in the box
        get boxCapacity() {
          return this.selectedBox?.size || 0;
        }

        /**
         * Cart lines whose variant has a product card badge (e.g. 30G) — matches
         * `assets/build-a-box.js` `cardBadgeCount`: +$4 (400¢) per unit on pack total.
         */
        get cardBadgeCount() {
          return this.cartItems.reduce((sum, line) => {
            const b = line.variant?.productCardBadge;
            const has = b != null && String(b).replace(/\s/g, "").length > 0;
            return sum + (has ? line.quantity : 0);
          }, 0);
        }

        cartCount(items = this.cartItems) {
          return (items || []).reduce(
            (sum, item) => sum + (item.quantity || 0),
            0,
          );
        }

        get spreadCart() {
          const out = [];
          this.cartItems.forEach((item) => {
            for (let i = 0; i < item.quantity; i++)
              out.push({ variant: item.variant, quantity: 1 });
          });
          return out;
        }

        updated(changedProperties) {
          if (!changedProperties.has("cartItems")) return;

          const previousItems = changedProperties.get("cartItems") || [];
          const wasFull = this.cartCount(previousItems) >= this.boxCapacity;
          const isFull =
            this.totalItems >= this.boxCapacity && this.boxCapacity > 0;
          const isMobile = this.screenSize < 993;

          // After the cart is cleared, the sticky hides — but cartVisualMinimized
          // may still be false from a previously full box. Reset so the next
          // items start minimized on mobile until the box is complete again.
          if (isMobile && this.totalItems === 0) {
            this.cartVisualMinimized = true;
          }

          // Keep mobile cart visual collapsed until the box is complete.
          if (isMobile && !wasFull && isFull) {
            this.cartVisualMinimized = false;
          }
        }

        cartItemFor(v) {
          return this.cartItems.find(
            (x) => x.variant.platformId === v.platformId,
          );
        }
        clearCart() {
          this.cartItems = [];
        }

        addToCart(variant) {
          if (this.totalItems >= this.boxCapacity) return;
          const ex = this.cartItemFor(variant);
          if (ex) this.setQuantity(variant, ex.quantity + 1, "adding");
          else this.cartItems = [...this.cartItems, { variant, quantity: 1 }];
        }

        setQuantity(variant, quantity, update) {
          if (this.totalItems === this.boxCapacity && update === "adding")
            return;
          if (quantity < 0) return;
          this.cartItems = this.cartItems
            .map((l) =>
              l.variant.platformId === variant.platformId
                ? { ...l, quantity }
                : l,
            )
            .filter((l) => l.quantity > 0);
        }

        // Extract numeric ID from a Shopify/Skio GID string or plain number
        gid(id) {
          const s = String(id);
          const part = s.includes("gid://") ? s.split("/").pop() : s;
          const n = parseInt(part, 10);
          return Number.isNaN(n) ? s : n;
        }

        filteredVariants(filterTitle) {
          const f = filterTitle || this.selectedFilter || "All Products";
          if (f === "All Products") return this.staticChildVariants;
          const lower = f.toLowerCase();
          return this.staticChildVariants.filter((v) =>
            (v.tags || []).some((t) => t.toLowerCase() === lower),
          );
        }

        /** Variants whose tags do not match any configured category (v1 parity). */
        getVariantsWithoutCategory(categoryTitles) {
          if (!this.staticChildVariants?.length || !categoryTitles?.length)
            return [];
          const lowered = categoryTitles.map((c) => String(c).toLowerCase());
          return this.staticChildVariants.filter((v) => {
            if (!v.tags || !Array.isArray(v.tags)) return true;
            return !v.tags.some((tag) =>
              lowered.includes(String(tag).toLowerCase()),
            );
          });
        }

        // Returns an integer SellingPlan ID for the Shopify Cart API, or null.
        sellingPlanForVariant(variantPlatformId) {
          if (
            this.purchaseOption !== "subscription" ||
            !this.selectedSellingPlan
          )
            return null;

          const raw = this.selectedSellingPlan.raw || {};

          // Candidates for the actual Shopify SellingPlan platform ID (in priority order):
          // 1. variantMapping → look up by full GID then numeric
          //    The mapping value can be a string GID or { planId, adjustedPrice }
          const map = raw.variantMapping || {};
          const variantFull = String(variantPlatformId);
          const variantNum = String(this.gid(variantPlatformId));
          const mapEntry = map[variantFull] || map[variantNum];
          // Normalise: extract planId if the entry is an object
          const fromMap = mapEntry?.planId || mapEntry;

          // 2. Direct fields the Skio API may expose on the plan object
          const candidates = [
            fromMap,
            raw.sellingPlanPlatformId,
            raw.platformId,
            raw.sellingPlanId,
            raw.id,
            this.selectedSellingPlan.platformId,
            this.selectedSellingPlan.id,
          ];

          for (const c of candidates) {
            if (!c) continue;
            const n = this.gid(c);
            if (typeof n === "number" && !Number.isNaN(n)) return n;
          }

          return null;
        }

        // ── Checkout ───────────────────────────────────────────

        async addIndividualItemsToCart(isSubscription = false) {
          const dynamicBoxId =
            this.dynamicBox?.boxId ||
            this.dynamicBox?.id ||
            this.dynamicBox?.platformId;
          const addOne = (cartItem) => {
            const data = {
              id: this.gid(cartItem.variant.platformId),
              quantity: cartItem.quantity,
            };
            if (isSubscription) {
              data.properties = {
                _dynamicBoxId: String(dynamicBoxId),
                // String to match PDP form FormData; Number `0` splits cart lines.
                _dynamicBoxIndex: '0',
              };
              const sp = this.sellingPlanForVariant(
                cartItem.variant.platformId,
              );
              if (sp && !Number.isNaN(sp)) {
                data.selling_plan = sp;
              } else {
                console.warn(
                  "[skio-v3] Could not resolve selling_plan for variant",
                  cartItem.variant.platformId,
                  "| selectedSellingPlan:",
                  this.selectedSellingPlan,
                );
              }
            }
            return fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            });
          };
          try {
            await this.cartItems.reduce(
              (p, item) => p.then(() => addOne(item)),
              Promise.resolve(),
            );
            if (window.NSHybridCart?.open) window.NSHybridCart.open();
            else window.location.href = "/cart";
          } catch (err) {
            this.errorMessage = err?.message || "Could not add box to cart";
            this.requestUpdate();
          }
        }

        checkout() {
          const isSub = this.purchaseOption === "subscription";
          this.addIndividualItemsToCart(isSub);
        }

        buyItOnce() {
          this.addIndividualItemsToCart(false);
        }

        // ── Size selector — mirrors build-a-box.js _tmplBoxSizeSelector ─

        boxSizeSelector() {
          if (this.staticBoxes.length <= 1) return html``;
          const maxSize = Math.max(...this.staticBoxes.map((b) => b.size));

          return html` <div class="skio-bab-box-size-selector">
            <h4 class="skio-bab__subtitle">
              <span class="skio-bab__subtitle-number">1</span>
              <span class="skio-bab__subtitle-name">Pack Size</span>
              <span class="skio-bab__subtitle-line"></span>
            </h4>
            <div class="skio-bab__pack-sizes">
              ${this.staticBoxes.map((box) => {
                const selected = this.selectedBox.size === box.size;
                const isMostPop =
                  box.size === maxSize && this.staticBoxes.length > 1;
                const cfg =
                  this._packConfig[String(box.displaySize || box.size * 12)];
                // save amount comes from fixedDiscountTier via buildBoxSizes()
                const save = box.save || null;
                return html` <div
                  class="${selected ? "selected" : ""}"
                  @click=${() => {
                    if (box.size < this.selectedBox.size) this.clearCart();
                    this.selectedBox = box;
                    this.syncSelectedSellingPlanForCurrentPack(true);
                  }}
                >
                  ${save
                    ? html` <span class="skio-bab__pack-size-save">
                        <span>Save</span><span>$${save}</span>
                      </span>`
                    : ""}
                  <span class="skio-bab__pack-size-label"
                    >${box.displaySize || box.size} PACK</span
                  >
                  ${isMostPop
                    ? html`<span class="skio-bab__most-popular-label"
                        >Most Popular</span
                      >`
                    : ""}
                </div>`;
              })}
            </div>
          </div>`;
        }

        // ── Cart total (price + compare at, from Liquid settings) ──

        cartTotal() {
          const cfg = this.currentPackCfg();
          if (!cfg || (!cfg.price && !cfg.comparePrice)) return html``;
          const surcharge = this.cardBadgeCount * 400;
          const displayCompare =
            cfg.comparePrice != null
              ? cfg.comparePrice + surcharge
              : cfg.comparePrice;
          const displayPrice =
            cfg.price != null ? cfg.price + surcharge : cfg.price;
          return html` <div class="skio-bab-cart__total">
            <span class="skio-bab-cart__total-label">Total</span>
            <div class="skio-bab-cart__total-prices">
              ${displayCompare
                ? html`<span class="skio-bab-cart__total-compare"
                    >${moneyV3(displayCompare)}</span
                  >`
                : ""}
              ${displayPrice
                ? html`<span class="skio-bab-cart__total-price"
                    >${moneyV3(displayPrice)}</span
                  >`
                : ""}
            </div>
          </div>`;
        }

        // ── Cart visual body (selected products + placeholders) ─

        cartBodyVisual() {
          const isMobile = this.screenSize < 993;

          return html` <div
            class="skio-bab-cart__visual ${isMobile && this.cartVisualMinimized
              ? "minimized"
              : ""}"
          >
            <h4 class="skio-bab__subtitle">
              <span class="skio-bab__subtitle-number">2</span>
              <span class="skio-bab__subtitle-name">Select Products</span>
              <span class="skio-bab__subtitle-quantity"
                >${this.totalItems}/${this.boxCapacity}</span
              >
              <span class="skio-bab__subtitle-line"></span>
              ${isMobile
                ? html` <button
                    class="skio-bab-cart__visual-toggle"
                    @click=${() => {
                      this.cartVisualMinimized = !this.cartVisualMinimized;
                      this.requestUpdate();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="${this.cartVisualMinimized ? "rotate" : ""}"
                    >
                      <g clip-path="url(#cv3_toggle)">
                        <path
                          d="M6 9L12 15L18 9"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="cv3_toggle">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>`
                : ""}
            </h4>

            ${!isMobile
              ? html`
                  ${this.spreadCart.map(
                    (item) =>
                      html` <div class="skio-bab-cart__visual-item">
                        <img
                          src="${item.variant
                            .imageSrc}${item.variant.imageSrc.includes("?")
                            ? "&"
                            : "?"}width=200"
                          alt="${item.variant.productTitle}"
                        />
                        <button
                          class="skio-bab-cart__remove"
                          @click=${() =>
                            this.setQuantity(item.variant, item.quantity - 1)}
                        ></button>
                      </div>`,
                  )}
                  ${this.placeholders()}
                `
              : html` <div class="skio-bab-cart__visual-items-wrapper">
                  ${this.spreadCart.map(
                    (item) =>
                      html` <div
                        class="skio-bab-cart__visual-item skio-bab-cart__visual-item--mobile"
                      >
                        <div class="skio-bab-placeholder-mobile">
                          <img
                            src="${item.variant
                              .imageSrc}${item.variant.imageSrc.includes("?")
                              ? "&"
                              : "?"}width=200"
                            alt="${item.variant.productTitle}"
                          />
                          <button
                            class="skio-bab-cart__remove"
                            @click=${() =>
                              this.setQuantity(item.variant, item.quantity - 1)}
                          ></button>
                        </div>
                      </div>`,
                  )}
                  ${Array.from({
                    length: Math.max(0, this.boxCapacity - this.totalItems),
                  }).map(
                    () =>
                      html` <div
                        class="skio-bab-cart__visual-item skio-bab-cart__visual-item--mobile"
                      >
                        <div class="skio-bab-placeholder-mobile">
                          <div class="skio-bab-placeholder-mobile__circle">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 6V18M6 12H18"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>`,
                  )}
                </div>`}
          </div>`;
        }

        placeholders() {
          const placeholder = html` <div class="skio-bab-cart__visual-item">
            <div class="skio-bab-cart__visual-placeholder">
              <div class="skio-bab-cart__visual-placeholder__circle">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 6V18M6 12H18"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>`;
          return Array.from({
            length: Math.max(0, this.boxCapacity - this.totalItems),
          }).map(() => placeholder);
        }

        // ── Plan picker (same markup as v1 planPicker()) ───────

        planPicker() {
          const plans = this.plansForCurrentPack();
          const firstPlan = plans[0] || null;

          return html` <fieldset class="skio-plan-picker">
            <!-- One-time -->
            <div
              class="skio-group-container skio-group-container--available
                  ${this.selectedSellingPlanGroup == null
                ? "skio-group-container--selected"
                : ""}
                  ${this.subscriptionFirst ? "skio-onetime-second" : ""}"
              @click=${() => {
                this.selectedSellingPlanGroup = null;
                this.selectedSellingPlan = null;
                this.purchaseOption = "onetime";
              }}
            >
              <input
                id="skio-one-time-v3"
                class="skio-group-input"
                type="radio"
              />
              <label class="skio-group-label" for="skio-one-time-v3">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="11"
                        stroke="currentColor"
                        stroke-width="1"
                      ></circle>
                      <circle
                        class="skio-radio"
                        cx="12"
                        cy="12"
                        r="7"
                        fill="currentColor"
                      ></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">One-time Purchase</div>
                </div>
              </label>
            </div>

            <!-- Subscription: one card + one frequency select (all plans as options) -->
            ${plans.length
              ? html` <div
                  class="skio-group-container skio-group-container--available
                    ${this.purchaseOption === "subscription"
                    ? "skio-group-container--selected"
                    : ""}"
                  @click=${() => {
                    this.selectedSellingPlanGroup = firstPlan;
                    this.selectedSellingPlan =
                      this.selectedSellingPlan || firstPlan;
                    this.purchaseOption = "subscription";
                  }}
                >
                  <input
                    id="skio-plan-v3-sub"
                    class="skio-group-input"
                    type="radio"
                  />
                  <label class="skio-group-label" for="skio-plan-v3-sub">
                    <div class="skio-group-topline">
                      <div class="skio-radio__container">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="11"
                            stroke="currentColor"
                            stroke-width="1"
                          ></circle>
                          <circle
                            class="skio-radio"
                            cx="12"
                            cy="12"
                            r="7"
                            fill="currentColor"
                          ></circle>
                        </svg>
                      </div>
                      <div class="skio-group-title">Subscribe &amp; Save</div>
                    </div>
                    <div class="skio-group-content">
                      ${plans.length > 1
                        ? html` <select
                            class="skio-frequency"
                            @mousedown=${(e) => e.stopPropagation()}
                            @click=${(e) => e.stopPropagation()}
                            @change=${(e) => {
                              const id = e.target.value;
                              const next =
                                plans.find(
                                  (p) => String(p.id) === String(id),
                                ) || null;
                              if (next) {
                                this.selectedSellingPlan = next;
                                this.selectedSellingPlanGroup = firstPlan;
                                this.purchaseOption = "subscription";
                              }
                              this.requestUpdate();
                            }}
                          >
                            ${plans.map(
                              (p) =>
                                html` <option
                                  value="${p.id}"
                                  ?selected=${this.selectedSellingPlan?.id ===
                                  p.id}
                                >
                                  Delivery ${p.name.toLowerCase()}
                                </option>`,
                            )}
                          </select>`
                        : html` <span class="skio-frequency skio-frequency--one"
                            >${firstPlan.name}</span
                          >`}
                      <div class="options-text">
                        <div class="options-text__item">
                          <div class="options-text__item-icon">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0075/5951/2137/files/Subscription_First_PDP.png?v=1721207778"
                              alt=""
                            />
                          </div>
                          <div class="options-text__item-text">
                            Adjust, skip or cancel any time
                          </div>
                        </div>
                        <div class="options-text__item">
                          <div class="options-text__item-icon">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0075/5951/2137/files/Slate_Milk_Subscription.png?v=1721207777"
                              alt=""
                            />
                          </div>
                          <div class="options-text__item-text">
                            Free shipping in the contiguous US
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>`
              : ""}
          </fieldset>`;
        }

        // ── Product card (same as v1 productCard()) ────────────

        productCard(variant) {
          const cartItem = this.cartItemFor(variant);
          const isOos = !variant.available;
          const boxFull = this.totalItems >= this.boxCapacity;
          const badge = variant.productCardBadge || null;

          return html` <div
            class="skio-bab-product-card"
            data-product-title="${variant.productTitle.replace(
              " - 12 Pack",
              "",
            )}"
            data-product-tags="${(variant.tags || []).join(",")}"
          >
            <div
              class="skio-bab-product-card__image"
              style="position:relative"
              @click=${() =>
                !isOos && !boxFull
                  ? cartItem
                    ? this.setQuantity(variant, cartItem.quantity + 1, "adding")
                    : this.addToCart(variant)
                  : null}
            >
              <img
                src="${variant.imageSrc}${variant.imageSrc.includes("?")
                  ? "&"
                  : "?"}width=400"
                alt="${variant.productTitle}"
              />
              ${badge
                ? html`<span class="skio-bab-product-card__badge"
                    >${badge}</span
                  >`
                : ""}
            </div>
            <div class="skio-bab-product-card__titlegroup">
              <div class="skio-bab-product-card__title">
                ${variant.productTitle.replace("- 12 Pack", "")}
              </div>
            </div>
            <div class="skio-bab-product-card__actions">
              ${cartItem
                ? html`${this.quantityPicker(variant)}`
                : html` <button
                    class="skio-bab-product-card__atc btn"
                    @click=${() => this.addToCart(variant)}
                    ?disabled=${boxFull || isOos}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      style="color:inherit"
                    >
                      <g clip-path="url(#clip0_v3_atc)">
                        <path
                          d="M12 5V19"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5 12H19"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_v3_atc">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    ${isOos ? html`Sold Out` : html`Add To Bundle`}
                  </button>`}
            </div>
          </div>`;
        }

        // ── Quantity picker (same SVG buttons as v1) ───────────

        quantityPicker(variant) {
          const cartItem = this.cartItemFor(variant);
          if (!cartItem) return html``;
          const boxFull = this.totalItems >= this.boxCapacity;
          return html` <div class="skio-bab-quantity-picker">
            <svg
              class="skio-bab-quantity-picker__btn"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style="cursor:pointer;background:#fff;border-radius:5px;"
              @click=${() => this.setQuantity(variant, cartItem.quantity - 1)}
              tabindex="0"
              role="button"
              aria-label="Decrease quantity"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#qp_minus_v3)">
                <path
                  d="M5 12H19"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="qp_minus_v3">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div class="skio-bab-quantity-picker__status">
              ${cartItem.quantity}
            </div>
            <svg
              class="skio-bab-quantity-picker__btn"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style="cursor:pointer;background:#fff;border-radius:5px;${boxFull
                ? "opacity:.5;pointer-events:none;"
                : ""}"
              @click=${() =>
                this.setQuantity(variant, cartItem.quantity + 1, "adding")}
              tabindex="0"
              role="button"
              aria-label="Increase quantity"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#qp_plus_v3)">
                <path
                  d="M12 5V19"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 12H19"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="qp_plus_v3">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>`;
        }

        // ── Cart header ────────────────────────────────────────

        cartHeader() {
          return html`<h2 class="skio-bab__title">
            ${this.dynamicBox?.title || "Bundle Builder"}
          </h2>`;
        }

        // ── Add to cart button (same CTA as v1) ────────────────

        addToCartButton() {
          const remaining = this.boxCapacity - this.totalItems;
          return html` <button
              type="button"
              @click=${this.checkout}
              class="skio-bab-cart__checkout btn"
              ?disabled=${this.totalItems < this.boxCapacity}
            >
              ${this.totalItems < this.boxCapacity
                ? html`ADD ${remaining} MORE
                  ${remaining === 1 ? "PACK" : "PACKS"}`
                : html`${this.purchaseOption === "subscription"
                    ? "SUBSCRIBE"
                    : "ADD TO CART"}`}
            </button>
            <p class="skio-bab-cart__info"></p>`;
        }

        // ── Buy It Once button ─────────────────────────────────

        buyItOnceButton() {
          const isDisabled = this.totalItems !== this.boxCapacity;
          const cfg = this.currentPackCfg();
          const surcharge = this.cardBadgeCount * 400;
          // In BAB legacy, "Buy It Once" uses one-time pricing (not sub).
          const oneTimeBasePrice =
            cfg?.comparePrice != null ? cfg.comparePrice : cfg?.price;
          const displayPrice =
            oneTimeBasePrice != null ? oneTimeBasePrice + surcharge : null;
          const priceLabel =
            displayPrice != null ? ` For ${moneyV3(displayPrice)}` : "";
          return html` <div class="skio-bab-cart__buy-it-once">
            <a
              class="skio-bab-cart__buy-it-once-btn ${isDisabled
                ? "disabled"
                : ""}"
              href="#"
              @click=${(e) => {
                e.preventDefault();
                if (!isDisabled) this.buyItOnce();
              }}
              >Buy It Once${priceLabel}</a
            >
          </div>`;
        }

        // ── Cart footer ────────────────────────────────────────

        cartFooter() {
          return html` <div class="skio-bab-cart__footer">
            <p class="skio-bab-cart-footer__description">
              ${this.cartFooterDescription}
            </p>
          </div>`;
        }

        // ── Filter click (mirrors v1 filterClick with scroll support) ─

        filterClick() {
          return (e) => {
            const div = e.target.closest(".skio-bab__filters-card");
            const filter = div?.getAttribute("data-filter");
            if (!filter) return;
            this.selectedFilter = filter;
            const behavior = this.filterBehavior || "scroll_to_category";
            this.requestUpdate();
            if (behavior === "scroll_to_category") {
              this.updateComplete.then(() => {
                let el;
                if (filter === "All Products") {
                  el =
                    this.querySelector(".skio-bab-grid__products") ||
                    document.querySelector(
                      "#skio-build-a-box .skio-bab-grid__products",
                    );
                } else if (filter === "Other") {
                  el = this.querySelector("#skio-bab-category-other");
                } else {
                  el = this.querySelector(
                    `#skio-bab-category-${this.slugify(filter)}`,
                  );
                }
                if (!el) return;
                const header = document.querySelector(
                  "header.site-header, .shopify-section-header, .header-wrapper, header",
                );
                const headerH = header ? header.offsetHeight : 0;
                const filtersBar =
                  this.querySelector(".skio-bab__filters") ||
                  document.querySelector(".skio-bab__filters");
                const filtersH = filtersBar ? filtersBar.offsetHeight : 0;
                const top =
                  el.getBoundingClientRect().top +
                  window.scrollY -
                  headerH -
                  filtersH -
                  24;
                window.scrollTo({ top, behavior: "smooth" });
              });
            }
          };
        }

        // ── Loading screen ─────────────────────────────────────

        loadingScreen() {
          return html` <div
            class="skio-loading ${this.loading ? "" : "loaded"}"
            style="${this.loading ? "" : "display:none"}"
          >
            <div class="lds-roller">
              ${[...Array(8)].map(() => html`<div></div>`)}
            </div>
          </div>`;
        }

        // ── Products grid content (with optional category grouping) ─

        productsGridContent() {
          const filters = this.filterButtons || [];
          const categories = filters
            .map((f) => f.settings?.filter_title)
            .filter(Boolean)
            .filter((t) => t !== "All Products");
          const isScroll =
            (this.filterBehavior || "scroll_to_category") ===
            "scroll_to_category";

          if (!categories.length) {
            return this.filteredVariants().map((v) => this.productCard(v));
          }

          if (isScroll) {
            const otherVariants = this.getVariantsWithoutCategory(categories);
            return html`
              ${categories.map((cat) => {
                const prods = this.filteredVariants(cat);
                if (!prods.length) return html``;
                const slug = this.slugify(cat);
                return html` <div
                  class="skio-bab-category"
                  id="skio-bab-category-${slug}"
                  data-category="${cat}"
                >
                  <h3 class="skio-bab-category__title">${cat}</h3>
                  <div class="skio-bab-products skio-bab-products--category">
                    ${prods.map((v) => this.productCard(v))}
                  </div>
                </div>`;
              })}
              ${otherVariants.length
                ? html` <div
                    class="skio-bab-category"
                    id="skio-bab-category-other"
                    data-category="Other"
                  >
                    <h3 class="skio-bab-category__title">Other</h3>
                    <div class="skio-bab-products skio-bab-products--category">
                      ${otherVariants.map((v) => this.productCard(v))}
                    </div>
                  </div>`
                : ""}
            `;
          }

          // filter mode: group by category, hide non-matching (v1 parity)
          const otherVariants = this.getVariantsWithoutCategory(categories);
          return html`
            ${categories.map((cat) => {
              const prods = this.filteredVariants(cat);
              if (!prods.length) return html``;
              const slug = this.slugify(cat);
              const visible =
                this.selectedFilter === "All Products" ||
                this.selectedFilter.toLowerCase() === cat.toLowerCase();
              return html` <div
                class="skio-bab-category${visible ? "" : " hidden"}"
                id="skio-bab-category-${slug}"
                data-category="${cat}"
              >
                <h3 class="skio-bab-category__title">${cat}</h3>
                <div class="skio-bab-products skio-bab-products--category">
                  ${prods.map((v) => this.productCard(v))}
                </div>
              </div>`;
            })}
            ${otherVariants.length
              ? html` <div
                  class="skio-bab-category${this.selectedFilter ===
                    "All Products" || this.selectedFilter === "Other"
                    ? ""
                    : " hidden"}"
                  id="skio-bab-category-other"
                  data-category="Other"
                >
                  <h3 class="skio-bab-category__title">Other</h3>
                  <div class="skio-bab-products skio-bab-products--category">
                    ${otherVariants.map((v) => this.productCard(v))}
                  </div>
                </div>`
              : ""}
          `;
        }

        // ── Main render (mirrors v1 render() layout exactly) ───

        render() {
          const isMobile = this.screenSize < 993;
          const filters = this.filterButtons || [];
          const isComplete = this.totalItems === this.boxCapacity;

          return html` ${this.loadingScreen()}
          ${isMobile
            ? html`
                <div id="skio-build-a-box" class="skio-bab">
                  <h2 class="skio-bab__title"></h2>
                  <h4 class="skio-bab__subtitle"></h4>
                  <div class="skio-bab-grid">
                    <!-- Mobile top: title + description + size selector only -->
                    <div
                      class="skio-bab-grid__cart skio-bab-cart skio-bab-grid__cart--allowed-${this.boxCapacity}"
                    >
                      ${this.cartHeader()}
                      ${this.mobilePageDescription
                        ? html`<p class="skio-bab__description">
                            ${this.mobilePageDescription}
                          </p>`
                        : ""}
                      ${this.boxSizeSelector()}
                    </div>
                    ${filters.length
                      ? html` <div class="skio-bab__filters">
                          ${filters.map(
                            (f) =>
                              html` <div
                                class="skio-bab__filters-card${this
                                  .selectedFilter === f.settings.filter_title
                                  ? " active"
                                  : ""}"
                                data-filter="${f.settings.filter_title}"
                                @click=${this.filterClick()}
                              >
                                <span>${f.settings.filter_title}</span>
                              </div>`,
                          )}
                        </div>`
                      : null}
                    <div class="skio-bab-grid__products skio-bab-products">
                      ${this.productsGridContent()}
                    </div>
                  </div>
                  ${this.cartFooter()}
                  <!-- Mobile sticky: cart visual (tray) + total + plan + CTA -->
                  ${this.totalItems > 0
                    ? html` <div
                        class="skio-bab-sticky_atc ${this.cartVisualMinimized
                          ? "minimized"
                          : ""}"
                      >
                        ${this.cartBodyVisual()} ${this.cartTotal()}
                        ${this.planPicker()} ${this.addToCartButton()}
                        ${isComplete ? this.buyItOnceButton() : ""}
                      </div>`
                    : ""}
                </div>
              `
            : html` <div id="skio-build-a-box" class="skio-bab">
                <h2 class="skio-bab__title"></h2>
                <h4 class="skio-bab__subtitle"></h4>
                ${filters.length
                  ? html` <div class="skio-bab__filters">
                      ${filters.map(
                        (f) =>
                          html` <div
                            class="skio-bab__filters-card${this
                              .selectedFilter === f.settings.filter_title
                              ? " active"
                              : ""}"
                            data-filter="${f.settings.filter_title}"
                            @click=${this.filterClick()}
                          >
                            <span>${f.settings.filter_title}</span>
                          </div>`,
                      )}
                    </div>`
                  : null}
                <div class="skio-bab-grid">
                  <div class="skio-bab-grid__products skio-bab-products">
                    ${this.productsGridContent()}
                  </div>
                  <div
                    class="skio-bab-grid__cart skio-bab-cart skio-bab-grid__cart--allowed-${this.boxCapacity}"
                  >
                    ${this.cartHeader()} ${this.boxSizeSelector()}
                    ${this.cartBodyVisual()} ${this.cartTotal()}
                    ${this.planPicker()} ${this.addToCartButton()}
                    ${isComplete ? this.buyItOnceButton() : ""}
                    ${this.cartFooter()}
                  </div>
                </div>
              </div>`}`;
        }
      }

      customElements.define("skio-build-a-box-v3", SkioBuildABoxV3Component);
    },
  );
}
